import { Box } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { ReactComponent as AddIcon } from 'assets/icons/addIcon.svg';
import { Spinner } from 'components';
import { useAuth } from 'hooks';
import { Links } from 'settings';
import { theme } from 'styles';

import { EmptyStateKpi, TargetItem } from '../../components';
import { useGetKpiDetailsQuery } from '../../hooks';
import { TARGETS_LIMIT } from './constants';
import {
  CreateButton,
  HeaderW,
  InnerContainer,
  PreviewSection,
  SectionTitle,
  SeeMoreLink,
} from './styled';

export function KpiPreview(): ReactElement {
  const { t } = useTranslation();
  const { isManager } = useAuth();
  const navigate = useNavigate();

  const { isLoading, targets } = useGetKpiDetailsQuery({
    limit: TARGETS_LIMIT,
    kpi_status: 'active',
  });

  const previewTargets = targets.slice(0, TARGETS_LIMIT);

  const targetsContent =
    previewTargets.length > 0 ? (
      <>
        {previewTargets.map((target) => (
          <TargetItem key={target.id} {...target} isPreview />
        ))}
      </>
    ) : (
      <Box sx={{ padding: '8px' }}>
        <EmptyStateKpi type="targets" />
      </Box>
    );

  return (
    <PreviewSection>
      {isLoading && <Spinner size={24} />}

      {!isLoading && (
        <>
          <HeaderW>
            <SectionTitle>{t('kpi.preview.ourTargets')}</SectionTitle>

            {isManager && (
              <CreateButton
                startIcon={<AddIcon style={{ fill: theme.palette.common.white }} />}
                onClick={(e) =>
                  navigate(Links.we.kpi.createTarget, { state: { from: e.currentTarget } })
                }
                style={{
                  height: '56px',
                  padding: '16px',
                  backgroundColor: theme.palette.info.main,
                  color: theme.palette.common.white,
                  fontSize: '14px',
                  fontWeight: 400,
                  borderRadius: '8px',
                  textTransform: 'none',
                }}
              >
                {t('kpi.preview.createKpi')}
              </CreateButton>
            )}
          </HeaderW>
          <InnerContainer>
            {targetsContent}

            {previewTargets.length > 0 && (
              <SeeMoreLink to={Links.we.kpi.index}>{t('kpi.preview.seeMore')}</SeeMoreLink>
            )}
          </InnerContainer>
        </>
      )}
    </PreviewSection>
  );
}
